import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { DiscoveryContext, useComponentData as setComponentData } from "@discoverycms/connector";
import { Autoplay, Navigation, Pagination } from "swiper";
import PropTypes from "prop-types";
import { ReactComponent as ArrowUnion } from "../../assets/images/landing/icons/arrow-union.svg";
// eslint-disable-next-line import/no-unresolved
import "swiper/css";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/navigation";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/pagination";
import DiscoveryTrendCard from "./DiscoveryTrendCard";

function DiscoveryTrendsCatalogue({ isLoading, componentId }) {
  const componentData = setComponentData(componentId).cards;
  const discoveryCards = componentData
    .map((card) => {
      // eslint-disable-next-line no-underscore-dangle
      return setComponentData(card._id, DiscoveryContext);
    })
    .filter((card) => card?.Card_enabled === true);

  const swiperRef = useRef();

  const useButtonKeyDown = (handler) => {
    return (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handler(e);
      }
    };
  };

  const handleKeyDownLeft = useButtonKeyDown(() => swiperRef.current?.slidePrev());
  const handleKeyDownRight = useButtonKeyDown(() => swiperRef.current?.slideNext());

  if (componentData === undefined) {
    return <span>Loading..</span>;
  }

  // eslint-disable-next-line no-nested-ternary
  return isLoading ? (
    <div id="hero-trends">
      <div className="skellyload" />
    </div>
  ) : discoveryCards.length === 1 ? (
    <div id="hero-trends" data-discovery-id={componentId}>
      <DiscoveryTrendCard cardData={discoveryCards[0]} isSingleCanvas />
    </div>
  ) : (
    <div id="hero-trends" data-discovery-id={componentId}>
      <Swiper
        slidesPerView={1}
        centeredSlides
        pagination={{ clickable: true }}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        loop
        className="trend-swiper"
        a11y={{
          enabled: true,
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
        }}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        breakpoints={{
          1299: {
            slidesPerView: 1,
            touchRatio: 1,
          },
        }}
        onSlideChange={(swiper) => {
          // Remove all slide buttons from tab order
          swiper.slides.forEach((slide, index) => {
            const links = slide.querySelectorAll("a");
            links.forEach((link) => {
              if (index === swiper.activeIndex) {
                // Only active slide button is focusable
                link.setAttribute("tabindex", "0");
              } else {
                // Hide inactive slide buttons from tab order
                link.setAttribute("tabindex", "-1");
              }
            });
          });
        }}
        onInit={(swiper) => {
          // Set initial state when carousel loads
          swiper.slides.forEach((slide, index) => {
            const links = slide.querySelectorAll("a");
            links.forEach((link) => {
              link.setAttribute("tabindex", index === swiper.activeIndex ? "0" : "-1");
            });
          });
        }}
        modules={[Autoplay, Navigation, Pagination]}
      >
        <div className="controls">
          <div
            className="circle-left"
            aria-label="Go to previous slide"
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDownLeft}
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <ArrowUnion width="16px" height="9px" className="control-left" />
          </div>

          <div
            className="circle-right"
            aria-label="Go to next slide"
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDownRight}
            onClick={() => swiperRef.current?.slideNext()}
          >
            <ArrowUnion width="16px" height="9px" className="control-right" />
          </div>
        </div>
        {discoveryCards.map((card) => (
          <SwiperSlide key={card?.Title_text}>
            <DiscoveryTrendCard cardData={card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

DiscoveryTrendsCatalogue.defaultProps = {
  isLoading: false,
};

DiscoveryTrendsCatalogue.propTypes = {
  isLoading: PropTypes.bool,
  componentId: PropTypes.string.isRequired,
};

export default DiscoveryTrendsCatalogue;
